module.exports = __webpack_public_path__ + "static/media/6.c7b04015.jpg";